import axios from 'axios'
import { getChannel, isKolCreatorChannel } from '@ms/utils/channel.js'
import { NETWORK_TIMEOUT, PENDING_CANCEL } from '@ms/config/message.js'
import { setSessionLoginStatus } from '@ms/utils/auth.js'
import { API_PREFIX } from 'composables/useRegion.js'
import { useAuthStore } from '@ms/stores/auth'
import { useCloudflareStore } from '@ms/stores/cloudflare'
import { ipRegion, updateIPRegion } from '@ms/components/Region/useStoreRegion.js'
import { getHeaders, appHeaders } from './headers.js'

/**
 * 创建 axios 实例
 * @param {Object} options.headers  请求头
 * @param {Function} options.parser     外部解析响应体方法
 * @returns
 */
export default function createService({ headers = {}, parser = null, baseURL }) {
  const service = axios.create({
    baseURL: baseURL || API_PREFIX,
    // timeout: 10000,
    headers: {
      ...getHeaders(),
      ...headers
    }
  })

  service.interceptors.request.use(
    (config) => {
      const channel = getChannel()
      if (channel && !isKolCreatorChannel(channel)) {
        config.headers.channel = channel
      }

      if (appHeaders.status) {
        Object.assign(config.headers, appHeaders.value)
      }

      return config
    },
    (error) => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
    }
  )

  service.interceptors.response.use(
    (response) => {
      const { nation, verifytoken } = response.headers
      if (nation && !ipRegion.value) {
        updateIPRegion(nation)
      }

      if (verifytoken) {
        useCloudflareStore().setVerifyToken(verifytoken)
      }

      if (parser) {
        return parser(response)
      }

      return response.data
    },
    (error) => {
      // pending cancel
      if (axios.isCancel(error)) {
        const cancelError = new Error(PENDING_CANCEL)
        // 标记是取消请求
        cancelError.canceled = true
        return Promise.reject(cancelError)
      }
      // network timeout
      if (!error.response) {
        return Promise.reject(new Error(NETWORK_TIMEOUT))
      }
      // 401 Unauthorized
      const { status } = error.response
      if (status === 401) {
        setSessionLoginStatus() // 登录凭证失效，标记登录状态false
        // 关闭登录态
        useAuthStore().update(false)
        const err = new Error('Not Login')
        err.login = false
        return Promise.reject(err)
      }

      if (status === 500 && typeof error.response.data === 'string' && /Blocked\sby\sAdGuard/i.test(error.response.data)) {
        return Promise.reject(new Error('Sorry, your request is blocked by an ads filter plugin of your browser. Please close it to have a better MSport experience.'))
      }

      if (status === 400 && error.response.data) {
        const { bizCode, message } = error.response.data
        error.bizCode = bizCode
        error.message = message
      }

      return Promise.reject(error)
    }
  )

  return service
}
